import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "2",
  viewBox: "-0.5 -0.5 15 15"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m13.5.5-13 13m0-13 13 13"
    }, null, -1)
  ]));
}
const interfaceClose = { render };
export {
  interfaceClose as default,
  render
};
//# sourceMappingURL=interface-close.svg.js.map
